import React, { Component } from 'react';
import './Steps.css';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import moment from 'moment';
import GoogleAutocomplete from 'react-google-autocomplete';

class Step3 extends Component {
  constructor(props) {
    super(props);

    let optionsDay = [];
    let optionsMonth = [];
    let optionsYear = [];

    for(let i = 1; i <= 31 ; i += 1) {
      optionsDay.push({
        value: (i < 10)?`0${i}`:i.toString(),
        label: i.toString(),
      });
    }

    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];


    for(let i = 0; i<12; i += 1) {
      optionsMonth.push({
        value: (i+1 < 10)?`0${i+1}`:(i+1).toString(),
        label: months[i],
      });
    }

    for(let i = parseInt(moment().format('YYYY'), 10) - 18; i >= parseInt(moment().format('YYYY'), 10) - 100; i -= 1) {
      optionsYear.push({
        value: i.toString(),
        label: i.toString(),
      });
    }

    this.state = {
      stepNumber: 3,
      fields: {
        firstName: '',
        lastName: '',
        dob_d: optionsDay[0].value,
        dob_m: optionsMonth[0].value,
        dob_y: optionsYear[0].value,
        city: '',
        country: '',
      },
      optionsDay,
      optionsMonth,
      optionsYear,
    };
  }

  allFieldsFilled() {
    const emptyFields = Object.keys(this.state.fields).filter(field => (
      this.state.fields[field].length === 0
    ));
    const { fields } = this.state;
    let diff = moment().diff(moment(`${fields.dob_y}-${fields.dob_m}-${fields.dob_d}`),'years');
    if(diff < 18) {
      return false;
    }
    return emptyFields.length === 0;
  }

  handleFieldChange(e, name) {
    let fields = this.state.fields;
    if(name === 'location') {
      fields.city = e.name;
      let filteredAddressComponents = e.address_components.filter(el => (
        el.types.includes('country')
      ));
      fields.country = filteredAddressComponents[0].short_name;
    } else {
      if (name.includes('dob')) {
        fields[name] = e;
      } else {
        fields[name] = e.target.value;
      }
    }

    this.setState({ fields });
  }

  handleNext(e) {
    e.preventDefault();
    this.props.saveData(this.state.fields);
    this.props.proceed(this.state.stepNumber);
  }

  render() {
    const fields = this.state.fields;
    return (
      <div className={`Step Step-container ${(this.props.active)?'active':''}`}>
        <div className="Step-title">
          Tell us about you...
        </div>
        <ul className="steps">
          <li className="step-number done">1</li>
          <li className="step-number done">2</li>
          <li className="step-number done">3</li>
          <li className="step-number">4</li>
          <li className="step-number">5</li>
          <li className="step-number">6</li>
        </ul>
        <div className="field-container text open">
          <div className="field-title">First name (not published)</div>
          <div className="row">
            <div className="col">
              <input onChange={e => this.handleFieldChange(e, e.target.name)} type="text" name="firstName" placeholder="First Name" />
            </div>
          </div>
        </div>
        <div className="field-container text open">
          <div className="field-title">Last name (not published)</div>
          <div className="row">
            <div className="col">
              <input onChange={e => this.handleFieldChange(e, e.target.name)} type="text" name="lastName" placeholder="Last Name" />
            </div>
          </div>
        </div>
        <div className="field-container select dob open">
          <div className="field-title">Your birthday:</div>
          <div className="row">
            <div className="col">
              <Select
                name="dob_d"
                onChange={value => this.handleFieldChange(value.value, 'dob_d')}
                options={this.state.optionsDay}
                placeholder="Day"
                value={fields.dob_d}
                clearable={false}
              />
            </div>
            <div className="col">
              <Select
                name="dob_m"
                onChange={value => this.handleFieldChange(value.value, 'dob_m')}
                options={this.state.optionsMonth}
                placeholder="Month"
                value={fields.dob_m}
                clearable={false}
              />
            </div>
            <div className="col">
              <Select
                name="dob_y"
                onChange={value => this.handleFieldChange(value.value, 'dob_y')}
                options={this.state.optionsYear}
                placeholder="Year"
                value={fields.dob_y}
                clearable={false}
              />
            </div>
          </div>
        </div>
        <div className="field-container google open">
          <div className="field-title">Your location</div>
          <div className="row">
            <div className="col">
              <GoogleAutocomplete
                onPlaceSelected={place => this.handleFieldChange(place, 'location')}
              />
            </div>
          </div>
        </div>
        <div className="row button-container space-between">
          <button
            className="btn btn-primary"
            onClick={(e) => {e.preventDefault();this.props.back(this.state.stepNumber);}}
          >
            Back
          </button>
          <button
            className="btn btn-primary"
            disabled={!this.allFieldsFilled()}
            onClick={(e) => this.handleNext(e)}
          >
            Next
          </button>
        </div>
      </div>
    );
  }
}

export default Step3;


// WEBPACK FOOTER //
// ./src/components/Step3.js